import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-tarif-quantite',
  templateUrl: './tarif-quantite.component.html',
  styleUrls: ['./tarif-quantite.component.css']
})
export class TarifQuantiteComponent implements OnInit {
  @Input() listTarifQte;
  @Input() showQteSupp;
  @Input() valeurQteSupp;
  @Input() isHisto;
  
  loadingIndicator: Boolean = false;
  qteSupp: Boolean = false;

  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  constructor(public common: CommonService) { }

  ngOnInit() {
    // console.log('isHisto',this.isHisto,'d',this.listTarifQte)
    this.listTarifQte = this.listTarifQte || [];
    this.qteSupp = this.valeurQteSupp || false;
  }

  showFiche() {
    this.hidefunction.emit();
  }

  hidemodal() {
    // console.log('aa')
    this.hidefunction.emit();
  }

  saveAgence() {
    this.valeurQteSupp = this.qteSupp;
    const event = {listTarifQte: this.listTarifQte, isQteSupp: this.qteSupp };
    this.validefunction.emit(event);
    this.hidefunction.emit();
  }

  addLigne() {
    const ctrl = this;
    this.listTarifQte.push({});
    this.listTarifQte = [...this.listTarifQte];
    setTimeout(function () {
      const elem = $('datatable-scroller:last-child')[0].lastElementChild;
      if(ctrl.listTarifQte.length && ctrl.listTarifQte.length===1) {
        $('.focusQ').find('#qte0').focus();
      } else {
        $('#qte' + (ctrl.listTarifQte.length - 1)).focus();
      }
    }, 600);
  }

  deleteLigne(row) {
    const temp = this.listTarifQte.filter(elt => elt !== row);
    this.listTarifQte = temp;
  }

  showInput(index?) {
    const ctrl = this;
    setTimeout(function () {
      if (index) {
        ctrl.common.focusElement('#qte' + index);
      } else {
        ctrl.common.focusElement('#qte' + (ctrl.listTarifQte.length - 1));
      }
    }, 510);
  }

  changeQteSupp() {
    this.listTarifQte.forEach(elt => elt.qteSupp = this.qteSupp);
  }

}
